import { render, staticRenderFns } from "./order_pay_dialog.vue?vue&type=template&id=e2f4e06c&scoped=true"
import script from "./order_pay_dialog.vue?vue&type=script&lang=js"
export * from "./order_pay_dialog.vue?vue&type=script&lang=js"
import style0 from "./order_pay_dialog.vue?vue&type=style&index=0&id=e2f4e06c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2f4e06c",
  null
  
)

export default component.exports